import React from 'react';
import { Alert, Button } from '@mui/material';

interface Props {
  /** What was looked for, in a few words: "product", "staged product", "report". */
  what: string;
  onBack: () => void;
}

/**
 * Shown over a list when a direct link names an item the server will not
 * serve: it does not exist, or it is not the caller's to open. The two read
 * the same on purpose.
 */
export const PermalinkNotFound: React.FC<Props> = ({ what, onBack }) => (
  <Alert
    severity="warning"
    sx={{ mb: 2 }}
    role="alert"
    action={
      <Button color="inherit" size="small" onClick={onBack}>
        Back to the list
      </Button>
    }
  >
    That {what} was not found, or you do not have access to it.
  </Alert>
);
